import {Type} from "class-transformer";
import {serializeType} from "@app/shared/classes/common";

import {AbstractItem} from "@app/shared/classes/item";
import {FundingType} from "@app/shared/enums/funding-type.enum";
import {ItemType} from "@app/shared/enums/item-type.enum";

export class PackingSlipItem {
  id: number;
  version: number;
  nameOrNumber?: string;
  subtype: ItemType;
  description?: string;
  fundingType: FundingType;
  isTaxable: boolean;
  qtyShipped: number;
  qtyBackOrdered: number;
  qtyOrdered: number;
  internalNotes: string;
  orderItemId: number;
  packingSlipItemId: number;
  abstractItemId: number;
  unitPrice: number;
  unitOfMeasureId: number;
  @Type(serializeType(AbstractItem)) abstractItemDetail: AbstractItem;

  // Transient fields
  unitOfMeasureDescription?: string;
  qtyAlreadyShipped?: number;
  quantityOnHand?: number;
  shippedAll: boolean;
}
